const widgets = [];

widgets.push({
    name: "StaticText",
    displayName: "Static text",
    description: "Static text",
    version: "1.0",
    options: [
        {
            name: "header",
            displayName: "Header",
            type: "string",
        },
        {
            name: "contentHTML",
            displayName: "Content HTML",
            type: "string"
        }
    ],
    layout: {
        minSize: 1,
        maxSize: Number.POSITIVE_INFINITY
    }
})

widgets.push({
    name: "AccountBalancesOverview",
    displayName: "Account balances overview",
    description: "Account balances overview",
    version: "1.0",
    options: [
        {
            name: "accountsToShow",
            displayName: "Accounts to show",
            type: "accountQuery"
        },
        {
            name: "defaultSortingField",
            displayName: "Default sorting field",
            type: "enum",
            options: [{name: "Owner", id: "owner"},
                {name: 'Actual balance', id: "actualBalance"},
                {name: "Balance date", id: "balanceDate"},
                {name: "Name", id: "name"},
                {name: "Currency", id: "currency"}]
        },
        {
            name: "defaultSortingDirection",
            displayName: "Default sorting direction",
            type: "enum",
            options: [{name: 'Ascending', id: "ASC"}, {name: "Descending", id: "DESC"}]
        },
    ],
    layout: {
        minSize: 1,
        maxSize: Number.POSITIVE_INFINITY
    }
})

widgets.push({
    name: "AccountBalancesForAccount",
    displayName: "Account balances history",
    description: "Account balances history",
    version: "1.0",
    options: [
        {
            name: "targetCurrency",
            displayName: "Target currency",
            type: "currency"
        },
        {
            name: "accountQuery",
            displayName: "Accounts",
            type: "accountQuery"
        },
        {
            name: "startDateExpr",
            displayName: "Start date expression",
            type: "dateExpression"
        },
        {
            name: "endDateExpr",
            displayName: "End date expression",
            type: "dateExpression"
        },
        {
            name: "showTotal",
            displayName: "Show total",
            type: "boolean"
        },
        // {
        //     name: "showOnlyTotal",
        //     displayName: "Show only total",
        //     type: "boolean"
        // },
        {
            name: "stackedChart",
            displayName: "Stacked chart",
            type: "boolean"
        }
    ],
    layout: {
        minSize: 1,
        maxSize: Number.POSITIVE_INFINITY
    }
})

widgets.push({
    name: "PaymentBatches",
    displayName: "Payment batches",
    description: "Payment batches",
    version: "1.0",
    options: [
        {
            name: "paymentBatchStatus",
            displayName: "Payment batch status",
            type: "enum",
            options: [{name: 'Created', id: "CREATED"}, {
                name: "In progress",
                id: "IN_PROGRESS"
            }, {name: "Waiting for approval", id: "WAITING_FOR_APPROVAL"}]
        }
    ],
    layout: {
        minSize: 1,
        maxSize: Number.POSITIVE_INFINITY
    }
})

widgets.push({
    name: "SimpleExchangeRate",
    displayName: "Simple exchange rate",
    description: "Simple exchange rate",
    version: "1.0",
    options: [
        {
            name: "exchangeRate",
            displayName: "Exchange rate",
            type: "exchangeRate"
        }
    ]
})

widgets.push({
    name: "SingleCashflowCell",
    displayName: "Single cashflow cell",
    description: "Show single cashflow value",
    version: "1.0",
    options: [
        {
            name: "cashflowReport",
            displayName: "Cashflow report",
            type: "cashflowReportDefinition"
        },
        {
            name: "fromBalancePart",
            displayName: "Take from balances part?",
            type: "boolean"
        },
        {
            name: "cashflowDateFrom",
            displayName: "Start date",
            type: "dateExpression"
        }, {
            name: "cashflowDateTo",
            displayName: "End date",
            type: "dateExpression"
        }, {
            name: "path",
            displayName: "Report path",
            type: "string"
        }, {
            name: "visualization",
            displayName: "Visualization type",
            type: "enum",
            options: [
                {name: 'Show value at start date', id: "VALUE_AT_DATE_FROM"},
                {name: "Show value at end date with diff", id: "VALUE_AT_DATE_TO_DIFF" },
                {name: "Show values sum over period", id: "SUM_OVER_PERIOD"},
                {name: "Show values average over period", id: "AVG_OVER_PERIOD"},
            ]
        }

    ]
})

widgets.push({
    name: "SimpleProcessHistory",
    displayName: "Simple process overview",
    description: "Simple overview of history of processes",
    version: "1.0",
    options: [
        {
            name: "processHistoryQuery",
            displayName: "Process query",
            type: "processHistoryQuery"
        }
    ]
})

widgets.push({
    name: "SimpleRunAction",
    displayName: "Simple process runner",
    description: "Runs single or multiple processes",
    version: "1.0",
    options: [
        {
            name: "contentHTML",
            displayName: "Content HTML",
            type: "string"
        },
        {
            name: "contentButton",
            displayName: "Button content",
            type: "string"
        },
        {
            name: "guard",
            displayName: "After press timeout",
            type: "number"
        },
        {
            name: "importDefinitionsToRun",
            displayName: "Jobs to run",
            type: "array-importDefinition"
        }
    ]
})



widgets.push({
    name: "OperationDefinitionsList",
    displayName: "Simple operation definitions list",
    description: "Displays simple operation definition list",
    version: "1.0",
    options: [

    ]
})

widgets.push({
    name: "OperationList",
    displayName: "Simple operation list",
    description: "Displays simple operation list",
    version: "1.0",
    options: [
        {
            name: "operationDefinitionId",
            displayName: "Operation definition",
            type: "operationDefinitionId"
        },
        {
            name: "operationDefinitionQuery",
            displayName: "Search query",
            type: "operationDefinitionQuery"
        }
    ]
})





widgets.push({
    name: "GeoAccountBalances",
    displayName: "Account balances map",
    description: "Account balances map",
    version: "1.0",
    options: [
        {
            name: "targetCurrency",
            displayName: "Target currency",
            type: "currency"
        },
        {
            name: "accountQuery",
            displayName: "Accounts",
            type: "accountQuery"
        },
        {
            name: "dateExpr",
            displayName: "Start date expression",
            type: "dateExpression"
        }
    ],
    layout: {
        minSize: 1,
        maxSize: Number.POSITIVE_INFINITY
    }
})

widgets.push({
    name: "SimpleResourceList",
    displayName: "Simple resource list",
    description: "Simple way to list categorized files",
    version: "1.0",
    options: [
        {
            name: "category",
            displayName: "Category",
            type: "string"
        },
        {
            name: "customName",
            displayName: "Custom name",
            type: "string"
        },
        {
            name: "dateFrom",
            displayName: "Start date expression",
            type: "dateExpression"
        },
        {
            name: "dateTo",
            displayName: "End date expression",
            type: "dateExpression"
        }
    ],
    layout: {
        minSize: 1,
        maxSize: Number.POSITIVE_INFINITY
    }
})

export default widgets;
